var map = {
	"./camera.svg": 4229,
	"./delete.svg": 7469,
	"./edit_black.svg": 7308,
	"./edit_green.svg": 5991,
	"./file_blank_gray.svg": 6707,
	"./more_vertical.svg": 7504,
	"./plus.svg": 6262,
	"./telegram.svg": 129,
	"./trash.svg": 4796,
	"./vk.svg": 8576,
	"./whatsapp.svg": 5900
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6851;